<template>
  <div class="home">
    <webapp-slider />
    <!-- <h1>This is Home page</h1> -->
    <section class="row skinLove-about-component">
      <div class="col-12 col-md-6">
        <!-- <div class="skinLove-img"></div> -->
        <img src="@/assets/images/cover7.png" alt="company-img" class="skinLove-img" />
      </div>
      <div class="col-12 col-md-6">
        <div class="skinLove-shortInfo-container">
          <h3 class="skinLove-shortInfo">
            კომპანია Skin Love-მა მსოფლიოს სანდო ბრენდების მაღალხარისხიანი
            პროდუქცია ერთ სივრცეში მოაქცია. უმაღლესი ხარისხის ორიგინალ კოსმეტიკას,
            სახისა და ტანის მოვლის საშუალებებს skinlove.ge სახლიდან გაუსვლელად,
            ხელსაყრელ ფასად გთავაზობთ.
          </h3>
        </div>
      </div>
    </section>
    <webapp-popularProducts />
    <section class="skinLove-img-bg">
      <h2 class="skinLove-img-bg-title">skinlove.ge</h2>
    </section>
    <section class="instagram-cont component-padding">
      <div class="text-center">
        <h3 class="component-title-cont">
          <span class="fa fa-instagram instagram-icon"></span>
          <span class="component-title">გამოგვყევი ინსტაგრამზე</span>
          <a
            href="https://www.instagram.com/skinlove.ge/"
            target="_blank"
            rel="noopener noreferrer"
            class="component-title component-title-link d-block"
          >@skinlove.ge</a>
        </h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-3" v-for="data in instagramItems" :key="data.id">
          <a :href="data.link" target="_blank" rel="noopener noreferrer" class="instagram-item">
            <img class="instagram-item-img" v-bind:src="data.image" />
            <span class="fa fa-instagram instagram-item-icon"></span>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import slider from "../components/slider.vue";
import popularProducts from "../components/popularProducts.vue";

export default {
  name: "App",
  components: {
    // HelloWorld
    "webapp-slider": slider,
    "webapp-popularProducts": popularProducts
  },
  data() {
    return {
      instagramItems: [
        {
          id: 1,
          image: require("../assets/images/balibodySh1.png"),
          link: "https://www.instagram.com/p/CBGr95XnR-X/"
        },
        {
          id: 2,
          image: require("../assets/images/VsShimmer1.jpg"),
          link: "https://www.instagram.com/p/CAKXZRvh-88/"
        },
        {
          id: 3,
          image: require("../assets/images/vsBronzer2.jpg"),
          link: "https://www.instagram.com/p/CCGH_mTggNY/"
        },
        {
          id: 4,
          image: require("../assets/images/glowEss2.png"),
          link: "https://www.instagram.com/p/CBQ39H4Hr4O/"
        }
      ]
    };
  }
};
</script>


<style lang="scss" scoped>
@import "~@/styles/global";
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");

.skinLove {
  &-about-component {
    margin: 15vh 0 3vh 0;
  }
  &-img {
    width: 100%;
    object-fit: cover;
    animation-name: shadowAnimation;
    animation-duration: 3s;
    animation-direction: alternate-reverse;
    animation-iteration-count: infinite;
    &-bg {
      background-image: url(~@/assets/images/ordinary-bg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-position: center;
      width: 100%;
      height: 50vh;
      position: relative;
      &-title {
        color: #fff;
        font-size: 8vh;
        font-family: cursive;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  &-shortInfo {
    font-size: $font-sm;
    color: $skyblueLight;
    font-family: $fontALKSanet;
    &-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: 2vh 1vh;
      text-align: center;
    }
  }
}
.instagram {
  &-icon {
    display: block;
    margin: 5vh 0 3vh;
    font-size: $font-xl;
  }
  &-item {
    position: relative;
    background: #000000;
    text-align: center;
    width: 100%;
    height: 100%;
    display: block;
    transition: all 0.35s ease-in-out;
    margin-top: 1vh;
    &-img {
      width: 100%;
      height: 55vh;
      object-fit: cover;
    }
    &-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      font-size: $font-lg;
      color: #000000;
      width: 60px;
      height: 60px;
      line-height: 60px;
      background: #ffffff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
      -webkit-transform: translate(-50%, -50%) scale(0);
      transform: translate(-50%, -50%) scale(0);
      transition: all 300ms 0ms cubic-bezier(0.6, -0.28, 0.735, 0.045);
    }
    &:hover .instagram-item-img {
      opacity: 0.3;
    }
    &:hover .instagram-item-icon {
      -webkit-transform: translate(-50%, -50%) scale(1);
      transform: translate(-50%, -50%) scale(1);
      transition: all 300ms 100ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
  }
}
@keyframes shadowAnimation {
  0% {
    box-shadow: 3px 3px 8px rgba(160, 137, 147, 0.9);
  }
  20% {
    box-shadow: 3px 3px 8px rgba(249, 218, 171, 0.9);
  }
  40% {
    box-shadow: 3px 3px 8px rgba(129, 21, 2, 0.9);
  }
  60% {
    box-shadow: 3px 3px 8px rgba(160, 248, 249, 0.9);
  }
  80% {
    box-shadow: 3px 3px 8px rgba(135, 140, 99, 0.9);
  }
  100% {
    box-shadow: 3px 3px 8px rgba(244, 223, 220, 0.9);
  }
}
/* =========== Responsive */

@media screen and (min-width: 768px) {
  .skinLove {
    &-shortInfo {
      font-size: $font-md;
      &-container {
        padding: 5vh;
      }
    }
    &-img-bg {
      height: 100vh;
    }
  }
}
</style>